import { render, staticRenderFns } from "./DotsHorizontalSolid.vue?vue&type=template&id=329875b9&"
import script from "./DotsHorizontalSolid.vue?vue&type=script&lang=ts&"
export * from "./DotsHorizontalSolid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports